// Operating basics for advisor calling (plan B7): call history («Mis llamadas» + manager view), team presence and
// simple per-advisor / per-line reports. Tenant + project restrictions on every read.
import * as C from './api-advisor-calls.js';
import { route, Ws } from './route-def.js';

export const advisorCallRoutes = {
  listAdvisorCalls: route({
    method: 'GET', path: '/workspaces/:workspaceId/advisor-calls', summary: 'Llamadas de asesores: las propias (asesor) o las del equipo con filtros (gerente)', tag: 'calls',
    minRole: 'advisor', params: Ws, query: C.ListAdvisorCallsQuerySchema, response: C.AdvisorCallListSchema,
  }),
  advisorCallReport: route({
    method: 'GET', path: '/workspaces/:workspaceId/advisor-calls/report', summary: 'Reporte de llamadas de asesores por asesor y por línea', tag: 'calls',
    minRole: 'manager', params: Ws, query: C.AdvisorCallReportQuerySchema, response: C.AdvisorCallReportSchema,
  }),
  getTeamPresence: route({
    method: 'GET', path: '/workspaces/:workspaceId/softphone/team', summary: 'Disponibilidad del equipo en el softphone', tag: 'softphone',
    minRole: 'manager', params: Ws, response: C.TeamPresenceSchema,
  }),
} as const;
